<template>
    <div class="row thank-you-page">
        <div class="col-md-12 col-lg-12 m-auto">
            <h1 class="title">{{ $('register_success_title') }}</h1>
            <h2 class="sub-title">{{ $('register_success_subtitle') }}</h2>

            <div class="form-group row button-wrapper">
                <div class="col-md-9 ml-md-auto">
                    <v-button :loading="form.busy"
                              type="link"
                              native-type="button"
                              @click="onSignInBtnClick">{{ $t('go_to_login_page') }}</v-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        metaInfo () {
            return { title: this.$t('login') }
        },

        data: () => ({

        })
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/thanks.vue